import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React from 'react';
import { IPlugin } from '../../types';
import { Footer } from '../footer/footer.comp';
import { Header } from '../header/header.comp';

interface ILayoutProps {
	title?: string;
	description?: string;
	image?: string;
	url?: string;
	serviceName?: string;
	children?: React.ReactNode;
	showHeader?: boolean;
	showFooter?: boolean;
	noindex?: boolean;
	nofollow?: boolean;
	apps?: IPlugin[];
	isDark?: boolean;
	isDeveloper?: boolean;
}

export const Layout = ({
	title,
	description,
	image,
	url,
	children,
	showHeader = false,
	showFooter = false,
	noindex = false,
	nofollow = false,
	isDark = false,
	isDeveloper = false,
	apps = [],
	serviceName = '',
}: ILayoutProps) => {
	const router = useRouter();
	const siteUrl = 'https://discover.commoninja.com'; // Replace with your actual domain
	const canonicalUrl = `${siteUrl}${router.asPath.split('?')[0]}`; // Strip query parameters

	return (
		<>
			<NextSeo
				noindex={noindex}
				title={`${title ? title : 'Find the best apps for your website | Common Ninja'
					}`}
				description={`${description
					? description
					: 'Discover the best apps, extensions, plugins, widgets, and modules for website builders & CMS platforms via the Common Ninja Search Engine.'
					}`}
				openGraph={{
					title: `${title ? title : 'Find the best apps for your website | Common Ninja'
						}`,
					description: `${description
						? description
						: 'Discover the best apps, extensions, plugins, widgets, and modules for website builders & CMS platforms via the Common Ninja Search Engine.'
						}`,
					url: url || 'https://discover.commoninja.com',
					images: [
						{
							url:
								image ||
								'https://website-assets.commoninja.com/distribution/1672309693637_og_general_blue.png',
							width: 1200,
							height: 630,
						},
					],
				}}
				canonical={canonicalUrl}
			/>
			<Head>
				<link rel="icon" href="https://www.commoninja.com/favicon.ico" />
			</Head>
			<Script
				id="embeddable-script"
				src="https://widgets.embeddable.co/sdk/latest/embeddable.js"
				defer
			/>
			{showHeader && <Header isDark={true} isDeveloper={isDeveloper} />}
			{children}
			{showFooter && <Footer isDark={true} />}
			<div className="embeddable-1w9qVZ3i5O" data-loader="false"></div>
		</>
	);
};
